/**
 * Sentinel when no assistant turn index is available for POST .../feedback.
 * Orchestrator requires turn_number >= 1; use this value (not 0) for “unknown” so it is never submitted.
 */
export const FEEDBACK_TURN_UNKNOWN = -1;
